"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/motoboy.ts
var motoboy_exports = {};
__export(motoboy_exports, {
  default: () => Motoboy
});
module.exports = __toCommonJS(motoboy_exports);
var Motoboy = class _Motoboy {
  id;
  name;
  secret_number;
  profileId;
  status;
  controls;
  daily;
  paid_at;
  whatsapp;
  email;
  password;
  expo_token;
  deleted_at;
  created_at;
  updated_at;
  profile;
  carts;
  constructor(motoboy) {
    this.id = motoboy.id;
    this.name = motoboy.name;
    this.secret_number = motoboy.secret_number;
    this.profileId = motoboy.profileId;
    this.status = motoboy.status;
    this.controls = motoboy.controls ?? {};
    this.daily = motoboy.daily;
    this.paid_at = motoboy.paid_at;
    this.whatsapp = motoboy.whatsapp;
    this.email = motoboy.email;
    this.password = motoboy.password;
    this.expo_token = motoboy.expo_token;
    this.deleted_at = motoboy.deleted_at;
    this.created_at = motoboy.created_at;
    this.updated_at = motoboy.updated_at;
    this.profile = motoboy.profile;
    this.carts = motoboy.carts;
  }
  get missingCredentials() {
    return !this.email || !this.password;
  }
  get appNotInstalled() {
    return !this.controls?.deviceModel;
  }
  get hasTrackfyPendencies() {
    return this.missingCredentials || this.appNotInstalled;
  }
  getTrackfyPendencies() {
    return _Motoboy.getTrackfyPendencies(this);
  }
  static getTrackfyPendencies(motoboy) {
    const missingCredentials = !motoboy.email || !motoboy.password;
    const appNotInstalled = !motoboy.controls?.deviceModel;
    const pendencies = [];
    if (missingCredentials) {
      pendencies.push("missing_credentials");
    }
    if (appNotInstalled) {
      pendencies.push("app_not_installed");
    }
    return {
      motoboyId: motoboy.id,
      motoboyName: motoboy.name,
      whatsapp: motoboy.whatsapp,
      pendencies,
      missingCredentials,
      appNotInstalled
    };
  }
  static hasTrackfyPendencies(motoboy) {
    if (!motoboy) {
      return false;
    }
    return _Motoboy.getTrackfyPendencies(motoboy).pendencies.length > 0;
  }
  static listTrackfyPendencies(motoboys = []) {
    return motoboys.filter((motoboy) => !motoboy.deleted_at && motoboy.status !== false).map((motoboy) => _Motoboy.getTrackfyPendencies(motoboy)).filter((item) => item.pendencies.length > 0);
  }
};
